import Vue from 'vue'
import Vuex from 'vuex'

// modules
import app from './modules/app'
import auth from './modules/auth'
import settings from './modules/settings'
import ecommerce from './modules/ecommerce'
import sidebar from './modules/sidebar'
import reports from './modules/reports'
import reportingData from './modules/reporting-data'
import dashboard from './modules/dashboard'
import orders from './modules/orders'
import users from './modules/users'
import guestDetails from './modules/guest-details'
import partners from './modules/partners'

const STORAGE_KEY = 'bo-v3'

Vue.use(Vuex)



const localStoragePlugin = store => {
    store.subscribe((mutation, state) => {
        // const store = {
        //     count: 1,
        //     auth: state.auth,
        //     user: state.user
        // }
        // // localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
        // if (mutation.type === 'clearAll') {
        //     localStorage.removeItem(STORAGE_KEY)
        // }
    })
}

const store = new Vuex.Store({
    strict: true,
    modules: {
        app,
        auth,
        settings,
        ecommerce,
        sidebar,
        reports,
        reportingData,
        dashboard,
        orders,
        users,
        guestDetails,
        partners
    },
    // plugins: [localStoragePlugin]
})


export function getItem (key) {
    return JSON.parse(localStorage.getItem(`bo-v3-${key}`))
}

export function setItem (key, value) {
    return localStorage.setItem(`bo-v3-${key}`, JSON.stringify(value))
}

export function removeItem (key) {
    return localStorage.removeItem(`bo-v3-${key}`)
}

export default store
